import { useEffect, useRef } from 'react';
import { subscribeProductEvents } from '../utils/productEventsHub';

const useProductEvents = (branchId, onEvent) => {
  const handlerRef = useRef(onEvent);

  useEffect(() => {
    handlerRef.current = onEvent;
  }, [onEvent]);

  useEffect(() => {
    if (!branchId) return undefined;
    const unsubscribe = subscribeProductEvents((event) => {
      if (branchId && event?.branchId && String(event.branchId) !== String(branchId)) {
        return;
      }
      return handlerRef.current?.(event);
    });
    return () => {
      unsubscribe();
    };
  }, [branchId]);
};

export default useProductEvents;
